import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { AppStateService } from 'src/app/core/services/app-state.service';

import { ClientDataInitializerService } from 'src/app/core/services/authentication/client-data-initializer.service';
import { AppThemeMode } from 'src/app/core/types/app-theme-mode.type';

@Component({
    selector: 'app-sms-preview-mobile',
    templateUrl: './sms-preview-mobile.component.html',
    styleUrls: ['./sms-preview-mobile.component.scss'],
    imports: [CommonModule]
})
export class SmsPreviewMobileComponent implements OnInit {
  appStateService = inject(AppStateService);
  //#region Properties
  @Input() mobileImageSrc: string = '';
  @Input() smsBody: string = '';
  @Input() senderNumber: any;
  @Input() isIosMobile: boolean = true;
  @Input() isSendSmartSmsRequestReport: boolean = false;

  agentLogo: string = '';
  //#endregion
  constructor(private clientDataService: ClientDataInitializerService) {}

  ngOnInit() {
    this.agentLogo = this.clientDataService.getCurrentClientData.agentLogo;
  }
}
